import React from 'react';
import { useHistory } from 'react-router-dom';

const PricingPage = () => {
  const history = useHistory();

  const handleSelectPlan = (plan) => {
    history.push('/checkout', { 
      plan: {
        id: plan.id,
        name: plan.name,
        hours: plan.hours,
        hourlyRate: plan.hourlyRate,
        price: plan.price
      }
    });
  };

  return (
    <div>
      <h1>Choose Your Plan</h1>
      <div>
        <h2>Basic Plan</h2>
        <p>10 hours of VA support</p>
        <p>$20/hour</p>
        <p>Total: $200/month</p>
        <button onClick={() => handleSelectPlan({
          id: 'basic',
          name: 'Basic Plan',
          hours: 10,
          hourlyRate: 20,
          price: 200
        })}>Select Basic Plan</button>
      </div>
      {/* Repeat similar blocks for Pro and Elite plans */}
    </div>
  );
};

export default PricingPage;